module.exports = __webpack_public_path__ + "static/img/20230316_02.c618e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230316_02.png
// module id = qO6C
// module chunks = 0